const { MODE } = import.meta.env;

export const getAuthority = () => {
  switch (MODE) {
    case 'development':
      return 'https://identity.napsterai.dev/';
    case 'staging':
      return 'https://identity.napsteraistage.com/';
    // The station kiosk is a production deployment with its own site origin
    case 'station':
    case 'production':
      return 'https://identity.napster.com/';
    default:
      return 'https://identity.napsterai.dev/';
  }
};

/**
 * True when the page was opened by the native macOS shell, which appends
 * `?platform=macos` and then injects tokens via `window.setAuthTokens`.
 *
 * Reads `window.location.search` directly (not react-router) so it can also be
 * used outside the router — e.g. from the store's initial state.
 */
export const isMacosPlatform = (): boolean => {
  if (typeof window === 'undefined') return false;
  return new URLSearchParams(window.location.search).get('platform') === 'macos';
};
